import { makeStyles } from "@material-ui/core/styles";
import feedback from '../../assets/feedbackImage.jpg';

export const useStyles = makeStyles(() => ({
  feedbackSectionWrapper: {
    margin: '80px auto',
    "@media (max-width: 1000px)": {
      marginBottom: 90
    }
  },
  feedbackCarousel: {
      backgroundColor: '#d5edf9',
      height: '100%',
      paddingTop: 80,
      paddingLeft: 80,
      paddingRight: 80,
    '& .slick-slider': {
      padding: '0 100'
    },
    "@media (max-width: 1200px)": {
      maxWidth: '60%',
      flexBasis: '60%'
    },
    "@media (max-width: 1000px)": {
      maxWidth: '100%',
      flexBasis: '100%',
      padding: 90,
      height: 'auto'
    }
  },
  sliderComponent: {
    '& .slick-dots': {
      top: '-25px',
      left: 0,
      "@media (max-width: 622px)": {
        display: 'none!important'
      }
    },
    '& slick-list': {
      paddingTop: 50
    },
    '& .slick-dots li': {
      width: '100px',
      height: 6,
      backgroundColor: 'white',
      '& button': {
        width: '100%'
      },
      '& button::before': {
        display: 'none'
      }
    }
  },
  feedbackSectionImage: {
    backgroundImage: `url(${feedback})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight: 500,
    "@media (max-width: 1200px)": {
      maxWidth: '40%',
      flexBasis: '40%'
    },
    "@media (max-width: 1000px)": {
      maxWidth: '100%',
      flexBasis: '100%',
    }
  }
}));